import React from 'react';
import { Link } from 'react-router-dom';
import Catageory_1 from '../../../assets/images/home_page_6/category/01.png';
import Catageory_2 from '../../../assets/images/home_page_6/category/02.png';
import Catageory_3 from '../../../assets/images/home_page_6/category/03.png';
import Catageory_4 from '../../../assets/images/home_page_6/category/04.png';
import Catageory_5 from '../../../assets/images/home_page_6/category/05.png';
import Catageory_6 from '../../../assets/images/home_page_6/category/06.png';

const categories = [
    { id: 1, name: "Computers & Laptop", img: Catageory_1, items: 6 },
    { id: 2, name: "Mobiles & Tablets", img: Catageory_2, items: 6 },
    { id: 3, name: "Game & Accessories", img: Catageory_3, items: 6 },
    { id: 4, name: "Camera & Photo", img: Catageory_4, items: 6 },
    { id: 5, name: "Electronics & Digital", img: Catageory_5, items: 6 },
    { id: 6, name: "Audio & Headphone", img: Catageory_6, items: 6 },
];

const Catageory = () => {
    return (
        <section id="shop-category-six" className="shop-category-six-main-block">
            <div className="container">
                <div className="deals-product-six-border">
                    <div className="row">
                        <div className="col-lg-4 col-md-5">
                            <div className="section">
                                <h6 className="section-heading-Categories">Shop By Categories</h6>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-7">
                            <p className="shop-category-six-des">
                                No handling fees + free shipping on orders over $35*
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {categories.map((category) => (
                        <div key={category.id} className="col-lg-2 col-md-4 col-6">
                            <div className="shop-category-six-block text-center">
                                <div className="shop-category-six-img">
                                    <Link to="#" title={category.name}>
                                        <img src={category.img} className="img-fluid" alt={category.name} />
                                    </Link>
                                </div>
                                <div className="shop-category-six-dtls">
                                    <h6 className="shop-category-six-heading">
                                        <Link to="#" title={category.name}>
                                            {category.name}
                                        </Link>
                                    </h6>
                                    <p>{category.items} Items</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Catageory;
